import { useSelector } from 'react-redux';

import { ca } from '@cian/analytics';

import { selectCategory } from '../../../selectors/page';
import { getCategoryAnalytics } from '../../../utils/getCategoryAnalytics';

export function useTracking() {
  const category = useSelector(selectCategory);

  const trackGoToOtherObjectClick = () => {
    ca('eventSite', {
      name: 'oldevent',
      category: getCategoryAnalytics(category),
      label: 'GoToOtherObject',
      action: 'Click',
    });
  };

  const trackMyHomeListringVisible = () => {
    ca('teaser', {
      product: {
        name: 'show_all_objects',
      },
    });
  };

  return {
    trackGoToOtherObjectClick,
    trackMyHomeListringVisible,
  };
}
